import { ShopByBodyType } from '@/components/molecules/ShopByBodyType/ShopByBodyType';
import { ShopByPopularMakes } from '@/components/molecules/ShopByPopularMakes/ShopByPopularMakes';
import { useRouter } from 'next/router';
import { FC } from 'react';

export const HomePageShopType: FC<{ makes: string[] }> = ({ makes }) => {
  const router = useRouter();

  const handleBodySearch = (bodyType: string) => {
    router.push(`/new-cars/${bodyType}`);
  };

  const handleMakeSearch = (make: string) => {
    router.push(`/new-cars/${make}`);
  };

  return (
    <div className="flex flex-col">
      <ShopByBodyType onClick={handleBodySearch} />
      <ShopByPopularMakes onClick={handleMakeSearch} allMakes={makes} />
    </div>
  );
};
